import React, { lazy } from 'react'

const TaxTypeListing = lazy(() =>
  import('./TaxTypeListing').then(module => ({
    default: module.TaxTypeListing,
  }))
)

const TaxListing = lazy(() =>
  import('./TaxListing/TaxListing').then(module => ({
    default: module.TaxListing,
  }))
)

const TaxSetupForm = lazy(() =>
  import('./TaxSetupForm/TaxSetupForm').then(module => ({
    default: module.TaxSetupForm,
  }))
)

const taxRoutes = [
  {
    props: { exact: true, path: '/common-setting/tax-type' },
    component: <TaxTypeListing />,
  },
  {
    props: {
      exact: true,
      path: '/common-setting/tax-type/:TaxSchemeTypeID/tax',
    },
    component: <TaxListing />,
  },
  {
    props: {
      exact: true,
      path: '/common-setting/tax-type/:TaxSchemeTypeID/tax/add',
    },
    component: <TaxSetupForm mode="add" />,
  },
  {
    props: {
      exact: true,
      path: '/common-setting/tax-type/:TaxSchemeTypeID/tax/:TaxID/edit',
    },
    component: <TaxSetupForm mode="edit" />,
  },
]

export default taxRoutes
